import { forEach } from 'es-toolkit/compat';
function appendScript({ src, id, async = false, attributes = {}, appendTo = 'body', }) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = async;
        script.src = src;
        forEach(attributes, (value, key) => {
            script.setAttribute(key, value);
        });
        script.onload = resolve;
        script.onerror = reject;
        if (id) {
            script.id = id;
        }
        document[appendTo].appendChild(script);
    });
}
function scriptExists(src) {
    return Boolean(document.querySelector(`script[src="${src}"]`));
}
export default async function addScript(options) {
    const { src } = options;
    if (!scriptExists(src)) {
        await appendScript(options);
    }
}
